module.exports = __webpack_public_path__ + "img/p401.3297657d.png";